<template>
  <div id="report">
    <common-header title="Report" divided>
      <template slot="btn">
        <el-col>
          <el-button
            class="btn btn-default btn-blue"
            v-show="!showQueryForm && queryType === 'custom'"
            style="float: right"
            @click="showQueryForm = true"
            >Query</el-button
          >
          <el-button
            class="btn btn-default btn-blue"
            v-show="showQueryForm"
            style="float: right"
            @click="
              submit();
              showQueryForm = false;
            "
            >Submit</el-button
          >
          <el-form v-show="!showQueryForm" style="float: right">
            <el-form-item label-width="100px">
              <el-select
                v-model="queryType"
                placeholder="Query Type"
                style="margin-right: 20px; width: 200px"
              >
                <el-option
                  v-for="opt in queryTypeOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </template>

      <el-row type="flex" :gutter="20" v-show="showQueryForm">
        <el-col :span="6">
          <el-form>
            <el-form-item label="Time"></el-form-item>
            <el-form-item label="Date Range">
              <el-select v-model="form.time_range" placeholder="Select range">
                <el-option
                  v-for="item in options.time_range"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-show="form.time_range === 'custom'"
              label="Custom Date"
            >
              <el-date-picker
                v-model="form.custom_time_range"
                :picker-options="pickerOptions"
                :clearable="false"
                type="daterange"
                start-placeholder="Start date"
                end-placeholder="End date"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="Interval">
              <el-select v-model="form.date_interval">
                <el-option
                  v-for="item in intervalOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="5">
          <el-form>
            <el-form-item label="Metrics"></el-form-item>
            <el-form-item>
              <el-row v-for="metric in metrics.base" :key="metric.value">
                <el-checkbox v-model="form['show_' + metric.value]">
                  {{ metric.label }}
                </el-checkbox>
              </el-row>
            </el-form-item>
            <el-collapse>
              <el-collapse-item title="Video" name="2">
                <el-form-item>
                  <el-row v-for="metric in metrics.video" :key="metric.value">
                    <el-checkbox v-model="form['show_' + metric.value]">
                      {{ metric.label }}
                    </el-checkbox>
                  </el-row>
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
          </el-form>
        </el-col>
        <el-col :span="4">
          <el-form>
            <el-form-item label="Dimensions"></el-form-item>
            <el-form-item>
              <el-row v-for="dimension in dimensions" :key="dimension.value">
                <el-checkbox v-model="form['group_by_' + dimension.value]">
                  {{ dimension.label }}
                </el-checkbox>
              </el-row>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="9">
          <el-form label-width="150px">
            <el-form-item label="Filters"></el-form-item>
            <el-form-item
              v-for="filter in filters"
              :key="filter.value"
              :label="filter.label"
            >
              <el-select
                v-model="form[filter.value + '_filter']"
                :multiple="!['advertiser', 'campaign'].includes(filter.value)"
                clearable
                filterable
                collapse-tags
                placeholder="Select filter"
              >
                <el-option
                  v-for="item in filterOptions[filter.value] ||
                    options[filter.value]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </common-header>

    <report-chart :data="report"></report-chart>
    <report-table :data="report"></report-table>
  </div>
</template>

<script>
import CommonHeader from "@/components/base/header";
import ReportChart from "@/components/pages/reports/chart";
import ReportTable from "@/components/pages/reports/table";
import MixReport from "@/components/mixins/report";
export default {
  data() {
    return {
      showQueryForm: false,
      queryType: "last7day",
      queryTypeOptions: [
        { label: "Last 7 days", value: "last7day" },
        { label: "Month to date", value: "month_to_date" },
        { label: "Quarter to date", value: "quarter_to_date" },
        { label: "Custom Query", value: "custom" },
      ],
      metrics: {
        base: [
          { value: "impressions", label: "Impressions" },
          { value: "clicks", label: "Clicks" },
          { value: "mrc_viewability", label: "MRC Viewability" },
          { value: "engagement", label: "Engagement" },
        ],
        video: [
          {
            value: "video_impression",
            label: "Impression",
          },
          {
            value: "video_start",
            label: "Start",
          },
          {
            value: "video_viewed_5s",
            label: "Viewed 5s",
          },
          {
            value: "video_first_quartile",
            label: "25% Completed Rate",
          },
          { value: "video_midpoints", label: "50% Completed Rate" },
          {
            value: "video_third_quartile",
            label: "75% Completed Rate",
          },
          { value: "video_complete", label: "100% Completed Rate" },
          { value: "video_skip", label: "Skip" },
        ],
      },
      dimensions: [
        { value: "advertiser", label: "Advertiser" },
        { value: "campaign", label: "Campaign" },
        { value: "creative_type", label: "Creative Format" },
        { value: "creative", label: "Creative" },
        { value: "placement", label: "Placement" },
      ],
      filters: [
        { value: "advertiser", label: "Advertisers" },
        { value: "campaign", label: "Campaigns" },
        { value: "creative_type", label: "Creative Formats" },
        { value: "creative", label: "Creatives" },
      ],
    };
  },
  async mounted() {
    await this.submit();
  },
  components: {
    CommonHeader,
    ReportChart,
    ReportTable,
  },
  computed: {
    filterOptions() {
      let options = {};

      if (this.options.campaign && this.options.campaign.length) {
        options.creative = _.filter(
          this.options.campaign,
          (i) =>
            !this.form.advertiser_filter ||
            i.advertiser === this.form.advertiser_filter
        );
      }

      if (this.options.creative && this.options.creative.length) {
        options.creative = _.filter(
          this.options.creative,
          (i) =>
            (!this.form.advertiser_filter ||
              i.advertiser === this.form.advertiser_filter) &&
            (!this.form.campaign_filter ||
              i.campaign === this.form.campaign_filter) &&
            (!this.form.creative_type_filter.length ||
              _.includes(this.form.creative_type_filter, i.type))
        );
      }

      if (this.form.creative_filter && this.form.creative_filter.length) {
        this.form.creative_filter = _.intersection(
          this.form.creative_filter,
          options.creative.map((i) => i.value)
        );
      }
      return options;
    },
  },
  mixins: [MixReport],
  watch: {
    async queryType(newVal) {
      if (newVal !== "custom") {
        await this.initForm(newVal, this.intervalOptions[0].value);
        await this.submit();
      } else {
        this.showQueryForm = true;
      }
    },
    "form.advertiser_filter"(newVal) {
      this.form.campaign_filter = null;
    },
  },
  methods: {
    initForm(time_range = "today", date_interval = "hour") {
      let form = {
        time_range,
        date_interval,
        custom_time_range: [
          moment()
            .add(-1, "month")
            .format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
      };
      _.forEach(this.metrics, (metric, k) => {
        metric.forEach((subMetric) => {
          form["show_" + subMetric.value] = true;
        });
      });
      _.forEach(this.dimensions, (dimension, k) => {
        if (dimension.value !== "placement")
          form["group_by_" + dimension.value] = true;
      });
      _.forEach(this.filters, (filter) => {
        form[filter.value + "_filter"] = ["advertiser", "campaign"].includes(
          filter.value
        )
          ? ""
          : [];
      });

      this.form = form;
    },
  },
};
</script>

<style lang="sass" scoped>
.filter.selected
  display: none
.el-select
  width: 100%
.el-collapse
  border-top: none
</style>
